import * as muiPalettes from "@mui/material/colors";
import { alphaVar as cssAlphaVar, tokenRefs } from "./tokens";
import { alpha as muiAlpha } from "@mui/material/styles";

export const colors = {
  ...muiPalettes,
  grey: tokenRefs.colors.muiGrey,
  blueGrey: tokenRefs.colors.muiBlueGrey,
};

export const alphaVar = (color: string, opacity: number) => cssAlphaVar(color, opacity) ?? muiAlpha(color, opacity);

export const grey = tokenRefs.colors.muiGrey;
export const blueGrey = tokenRefs.colors.muiBlueGrey;
